import { FullPageLoader } from "components/loadingIndicator";
import { AuthProvider } from "domain/auth/authProvider";
import { logoutPageUrl, oktaRedirectUrl, oktaRedirectUrlLegacy } from "domain/auth/routes";
import { FlightSearchProvider } from "domain/flightSearch/hooks/flightSearchContext";
import { flightsPageUrl, searchPageUrl } from "domain/flightSearch/routes";
import { UserSettingsProvider } from "domain/userSettings/hooks/userSettingsContext";
import React, { lazy, Suspense } from "react";
import { CookiesProvider } from "react-cookie";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

import { LoginCallback, SecureRoute } from "@okta/okta-react";

const queryClient = new QueryClient();

const FlightResultsPage = lazy(() => import("./views/flightResultsPage"));
const FlightSearchPage = lazy(() => import("./views/flightSearchPage"));
const LogOutPage = lazy(() => import("./views/logOutPage"));
const NotFoundPage = lazy(() => import("./views/notFoundPage"));

const homePageUrl = "/";
const homePageUrlLegacy = "/ferryfinder";

const AppRoutes = () => (
  <Switch>
    <Route path={[oktaRedirectUrl, oktaRedirectUrlLegacy]} children={<LoginCallback />} />
    <Route path={logoutPageUrl} exact children={<LogOutPage />} />
    <Route path={homePageUrlLegacy} exact children={<Redirect to={homePageUrl} />} />
    <SecureRoute path={[homePageUrl, searchPageUrl]} exact children={<FlightSearchPage />} />
    <SecureRoute path={flightsPageUrl} exact children={<FlightResultsPage />} />
    <SecureRoute path="*" children={<NotFoundPage />} />
  </Switch>
);

export const App = () => (
  <BrowserRouter>
    <CookiesProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <UserSettingsProvider>
            <FlightSearchProvider>
              <Suspense fallback={<FullPageLoader />}>
                <AppRoutes />
              </Suspense>
            </FlightSearchProvider>
          </UserSettingsProvider>
        </AuthProvider>
      </QueryClientProvider>
    </CookiesProvider>
  </BrowserRouter>
);
